import React, { Fragment, memo } from "react";
import { QuestionType } from "components/HHQComponents";
import { ViewMath } from "components/HHQComponents";
import DienVaoChoTrong from 'components/HHQComponents/CauHoiComponent/DiemVaoChoTrong';
import DungSai from "components/HHQComponents/CauHoiComponent/DungSai";
import LuaChon from "components/HHQComponents/CauHoiComponent/LuaChon";
import PhuHop from "components/HHQComponents/CauHoiComponent/PhuHop";
import TieuLuan from "components/HHQComponents/CauHoiComponent/TieuLuan";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { TestDetailQuizModel } from '../../../models/test-detail.model';

interface QuestionItemProps {
    question: TestDetailQuizModel;
    index: number;
    handleUpdateQuestions: (newValue: TestDetailQuizModel) => void;
    apiService: any;
    setShowLoading: (isLoading: boolean) => void;
    toast: any;
    baseImageUrl: string;
    isMobile: boolean;
    isPreview: boolean;
}
const CauHoiComponent: React.FC<QuestionItemProps> = ({
  question,
  index,
  handleUpdateQuestions,
  apiService,
  setShowLoading,
  toast,
  baseImageUrl,
  isMobile,
  isPreview = false,
}) => {
  const renderAnswer = (answers: any, question: any) => {
    if (question.testQuestionTypeCode === QuestionType.dung_sai)
      return <DungSai answers={answers} question={question} handleUpdateQuestions={handleUpdateQuestions} />;
    if ([QuestionType.nhieu_lua_chon, QuestionType.mot_lua_chon].includes(question.testQuestionTypeCode))
      return <LuaChon answers={answers} question={question} handleUpdateQuestions={handleUpdateQuestions} />;
    if (question.testQuestionTypeCode === QuestionType.phu_hop)
      return <PhuHop answers={answers} question={question} handleUpdateQuestions={handleUpdateQuestions} />;
    if (question.testQuestionTypeCode === QuestionType.tieu_luan)
      return <TieuLuan question={question} handleUpdateQuestions={handleUpdateQuestions} apiService={apiService} baseImageUrl={baseImageUrl} setShowLoading={setShowLoading} toast={toast} />;
    return <div>Câu hỏi không đúng định dạng {question?.testQuestionTypeCode}</div>;
  };
  return (
    <div className="question-item" key={`question${question?.id}-${index}`}>
      <div className="question-header">
        <div className="number">Câu hỏi {index + 1}</div>
        <div className="point">{question.point} điểm</div>
      </div>
      <div className="question-content">
        {[QuestionType.dien_vao_cho_trong, QuestionType.dien_vao_nhieu_khoang_trong, QuestionType.nhieu_trinh_tha_don_xuong].includes(question.testQuestionTypeCode) ? (
          <div>
            <DienVaoChoTrong question={question} isEdit={false} handleUpdateQuestions={handleUpdateQuestions} />
          </div>
        ) : !isMobile && question?.hasOwnProperty("isLayoutSplitVertical") && !question.isLayoutSplitVertical ? (
          <Splitter>
            <SplitterPanel className="flex align-items-center p-2">
              <ViewMath>
                <div className="name" dangerouslySetInnerHTML={{ __html: question?.content || "" }} />
              </ViewMath>
            </SplitterPanel>
            <SplitterPanel className="flex align-items-center p-2">
              {renderAnswer(question.testQuestionAnswers, question)}
            </SplitterPanel>
          </Splitter>
        ) : (
          <Fragment>
            <ViewMath>
              <div className="name" dangerouslySetInnerHTML={{ __html: question?.content || "" }} />
            </ViewMath>
            {renderAnswer(question.testQuestionAnswers, question)}
          </Fragment>
        )}
        {isPreview && question?.description && (
          <div>
            <b>Gợi ý: </b>
            <ViewMath>
              <span className="name" dangerouslySetInnerHTML={{ __html: question?.description || "" }} />
            </ViewMath>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(CauHoiComponent);